import { CheckBoxWithLabelWidget } from '@tableau/widgets';
import React from 'react';

import { TypeUnsafeTranslation } from '~src/common/react/IReactTranslateService';

import { IFilterControl, submitUrlQuery } from './FilterPanel';
import { filterComponent } from './FilterPanelStyles';


export interface CheckBoxFilterProps {
  readonly filterControl: IFilterControl;
  readonly shouldClear: boolean;
}

export function CheckBoxFilter(props: CheckBoxFilterProps) {
  const { filterControl } = props;
  const defaultCheckedState = false;

  const [isChecked, setIsChecked] = React.useState<boolean>((filterControl.value as boolean) ?? defaultCheckedState);

  const handleChange = (checked: boolean) => {
    setIsChecked(checked);

    const params = filterControl.definition.valueToParams(checked);
    submitUrlQuery(params);
  };

  // Needed for updates from the URL
  React.useEffect(
    () => {
      const updatedValue = filterControl.value;
      if (isChecked !== updatedValue) {
        setIsChecked(updatedValue ?? defaultCheckedState);
      }
    },
    // This deps array was noncompliant before we enabled the lint rule. If you’re here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filterControl.value]
  );

  // Listen for clearing all filters
  React.useEffect(
    () => {
      if (props.shouldClear) {
        setIsChecked(defaultCheckedState);
      }
    },
    // This deps array was noncompliant before we enabled the lint rule. If you’re here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.shouldClear]
  );

  return <div className={filterComponent}>
    <CheckBoxWithLabelWidget
      checked={isChecked}
      handleChange={handleChange}
      label={TypeUnsafeTranslation.translate(filterControl.definition.name)}
      removeLeftMargin={true}
      testId={'boolean-filter-'+filterControl.definition.name}
    />
  </div>;
}

